@if (totalRows !== 0) {
  <div class="table-container">
    <div class="title-row">
      @for (colName of this.columnConfig.columnTitles; track colName) {
        <div class="data-col">
          {{ colName.key | translate : colName.params }}
        </div>
      }
    </div>
    <div class="data-container">
      @for (cardRow of tableData; track cardRow; let rowIndex = $index) {
        @if (rowIndex < amountOfRowsToDisplay) {
          <div class="data-row">
            @for (col of this.columnConfig.columnTitles; track col; let dataIndex = $index) {
              <div class="data-col">
                <span class="current">
                  <span class="value">
                    @if (dataIndex === nameDataIndex) {
                      {{ cardRow.name }}
                    }
                    @if (dataIndex === valueDataIndex) {
                      {{ cardRow.value }}
                      <span
                        class="previous"
                      [ngClass]="{
                        'positive-change': cardRow.changeDirection === 'positive-change',
                        'negative-change': cardRow.changeDirection === 'negative-change',
                        'no-change': cardRow.changeDirection === 'no-change'
                      }"
                        >
                        @if (cardRow.trend !== 'no-trend') {
                          @if (cardRow.trend === 'trend-up') {
                            <span class="trend">
                              <mat-icon>trending_up</mat-icon>
                            </span>
                          }
                          @if (cardRow.trend === 'trend-down') {
                            <span class="trend">
                              <mat-icon>trending_down</mat-icon>
                            </span>
                          }
                        } @else {
                          No change
                        }
                        @if (cardRow.trend !== 'no-trend') {
                          <span class="value">
                            <ng-container>
                              {{ cardRow.diff }}
                              @if (dataType === 'percentage') {
                                <span>%</span>
                              }
                            </ng-container>
                          </span>
                        }
                      </span>
                    }
                  </span>
                </span>
              </div>
            }
          </div>
        }
      }
      @if (amountOfRowsToDisplay < totalRows) {
        <button mat-button color="accent" (click)="toggleShowAllRows()">
          Show All (+{{ totalRows - amountOfRowsToDisplay }})
        </button>
      }
      @if (showAllRows) {
        <button mat-button color="accent" (click)="toggleShowAllRows()">Show Less</button>
      }
    </div>
  </div>
} @else {
  <div class="no-data-container">
    <div class="no-data">
      <mat-icon>bar_chart</mat-icon>
      <h3>No data yet</h3>
    </div>
  </div>
}

